import script from "./Aims.vue?vue&type=script&setup=true&lang=js"
export * from "./Aims.vue?vue&type=script&setup=true&lang=js"

import "./Aims.vue?vue&type=style&index=0&id=6a9d0195&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a9d0195"]])

export default __exports__